module.exports = __webpack_public_path__ + "style/img/RE_icon_Cover.3e93e76f.png";